
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersNight as ObiLightningSnowShowersNightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-night.js';
 
 
 

 
 export const ObiLightningSnowShowersNight = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-night',
   elementClass: ObiLightningSnowShowersNightElement,
   events: {
     
   }
  });
 
 